import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faSearch, faEdit, faFileAlt, faCheck, faSave, faFileSignature, faFile, faEye } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import MainCard from 'components/MainCard/MainCard';

//Components
import Loading from '../../../../components/Loading/Loading';
import TabelaEnderecos from './TabelaEnderecos';
import ModalCustomized from 'components/Modal/Modal';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
import TextField from 'components/TextField/TextField';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import { showMessage } from 'helpers/message';
import { abrirPDF } from '../../../../helpers/abrirPDF';
import { showQuestion } from 'helpers/message';

//API
import gerador_api from 'api/gerador_api';
import usuario_api from 'api/usuario_api';

//Context
import { useAuth } from "../../../../context/auth";
import acesso_api from 'api/acesso_api';

export default function AnaliseGeradorLocalidade({btnVoltar, geradorSelecionado}) {
    const { session } = useAuth();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(geradorSelecionado);

    //Estado que guarda os campos que estão incorretos
    const [errors, setErrors] = useState({});

    //Estado de controle de exibição do modal de recusa de recebimento de residuos
    const [openModalRecusa, setOpenModalRecusa] = useState(false);

    // Armazena o texto da justificativa da reprovação
    const [justificativaReprova, setJustificativaReprova] = useState("")

    // Armazena os dados da linha para aprovação/recusa
    const [rowDataRecusa, setRowDataRecusa] = useState(null);

    const [visualizarModalAnalise, setVisualizarModalAnalise] = useState(0)
    const [fichaAnaliseLocalidade, setFichaAnaliseLocalidade] = useState()
    //Cabeçalhos da tabela de listagem de ações 
    const headersTabela = [
        { value: "Data/Hora", objectValue: "dataHora", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Observações", objectValue: "observacoes", align: "left" },
        { value: "Usuário Aprovação", objectValue: "nomeUsuario", align: "left" },
    ];

    //Controle de exibição do modal de recusa na tela
    const toggleModalRecusa = () => {
        setOpenModalRecusa(!openModalRecusa);
    };

    //Controle de exibição do modal de recusa na tela
    const toggleModalFicaAnalise = () => {
        setVisualizarModalAnalise(!visualizarModalAnalise);
    };

    //Função para aprovar ou reprovar uma localidade
    function analisarLocalidade(rowData) {
        
        if (rowData.status == "Ativo" ) {
            showQuestion("Aviso",
                `Tem certeza que deseja aprovar essa localidade?`,
                "info", (confirmation) => analisarLocalidadeConfirmation(confirmation, rowData));
        }
        else {
            setRowDataRecusa(rowData)
            setOpenModalRecusa(true)
        }
    }

    // Função de validação para verificar se a justificativa está preenchida
    const validarJustificativa = () => {
        const _errors = {};
        if (!justificativaReprova.trim()) {
            _errors.justificativaReprova = "";
        }
        return _errors;
    };

    async function analisarLocalidadeConfirmation(confirmation, rowData) {
        const _gerador = { ...gerador };
        
        if (confirmation) {
            _gerador.localidades = _gerador.localidades.map((value, index) => {
                if (rowData.tableData.id === index) {
                    return { ...value, ...rowData }; 
                }
                return value; 
            });

            // Valida justificativa
            const _errors = validarJustificativa();
            setErrors(_errors);
            if (Object.keys(_errors).length > 0 && rowData.status !== "Ativo") return; 
            
            _gerador.analiseLocalidade = {
                tbGeradorLocalidades_Id: rowData.id,
                tbUsuarios_Id: session?.usuario_Id,
                Status: rowData.status == "Ativo" ? "Aprovado" : "Reprovado",
                Observacoes: justificativaReprova
            }

            setOpenModalRecusa(false)
            setJustificativaReprova("")
            setLoading(true);
            await gerador_api.Put(_gerador).then(response => {
                showMessage("Sucesso", `Localidade ${rowData.status == "Ativo" ? "aprovada" : "reprovada"} com sucesso!`, "success");
                setGerador(_gerador);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
            .finally(f => setLoading(false));
        }
    }

    // Função para exibir o modal do histórico de análises da localidade
    const visualizarAnaliseLocalidade = (localidade_Id) => {
        setVisualizarModalAnalise(true);
        setLoading(true);
    
        gerador_api.GetAnaliseLocalidade(localidade_Id)
            .then(response => {
                return Promise.all(response.data.map(async m => {
                    const nomeUsuario = await usuario_api.getItem(m.tbUsuarios_Id).then(retorno => retorno.data.nome);
                    return {
                        ...m,
                        dataHora: moment(m.dataHora).format("DD/MM/YYYY HH:mm:ss"),
                        nomeUsuario: nomeUsuario
                    };
                }));
            })
            .then(dataFormatada => {
                setFichaAnaliseLocalidade(dataFormatada);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    };

    const [permissaoEditarGerador, setPermissaoEditarGerador] = useState()
    useEffect(() => {
        setLoading(true)
        acesso_api.getFuncionalidadesAcesso(session?.acesso?.sigla).then(response => {
            setPermissaoEditarGerador(response.data.filter(f => f.funcao == "Cadastros.Gerador")[0])
        })
        .catch(e => showMessage("Aviso", e.message, "error", null))
        .finally(() => setLoading(false));
    }, [])

    return (
        <MainCard btnVoltar={btnVoltar} >
            <div style={{ color: "#666" }}>
                <div>
                    {loading && <Loading />}
                    <ModalCustomized title={"Reprovar localidade"} isOpen={openModalRecusa} toggle={toggleModalRecusa} onClickBtnAction={() => {analisarLocalidadeConfirmation(true, rowDataRecusa)}} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar reprova</>} btnActionColor={"success"} btnClose>
                        <Row>
                            <Col md="12" lg="12">
                                <TextField label={"Justificativa da reprova"} type="textarea" name={"observacao"} value={justificativaReprova} onChange={e => setJustificativaReprova(e.target.value)} invalid={!!errors.justificativaReprova} />
                            </Col>
                        </Row>
                    </ModalCustomized>
                    <ModalCustomized 
                        title={"Ficha Análise Localidade"} 
                        isOpen={visualizarModalAnalise} 
                        toggle={toggleModalFicaAnalise} 
                        onClickBtnAction={() => {analisarLocalidadeConfirmation(true, rowDataRecusa)}} 
                        btnActionColor={"success"} btnClose
                    >
                        <TabelaListagem
                            title="Histórico"
                            headers={headersTabela}
                            items={fichaAnaliseLocalidade}
                            options={{
                                print: false,
                                search: false,
                                pagination: false
                            }}
                        />
                    </ModalCustomized>
                    <h5 className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center' style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Identificação do gerador</span></h5>
                    <Row>
                        <Col md="12" lg="12">
                            <p><span className="fw-bold">Fantasia: </span> {gerador.fantasia}</p>
                        </Col>
                        <Col md="12" lg="12">
                            <p><span className="fw-bold">Razão social: </span> {gerador.razao}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">CPF / CNPJ: </span> {mascaras.cpfcnpjMask(gerador.cpfcnpj)}</p>
                        </Col>
                        {!!gerador?.codigoCadastro &&
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Código Cadastro: </span> {gerador.codigoCadastro}</p>
                            </Col>
                        }
                        <Col md="12" lg={4}>
                            <p><span className="fw-bold">Email: </span> {!gerador.email ? "Não informado" : gerador.email}</p>
                        </Col>
                        <Col md="12" lg={!!gerador?.codigoCadastro ? 12 : 4}>
                            <p><span className="fw-bold">Responsavel: </span> {!gerador.contato ? "Não informado" : gerador.contato}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Fone: </span> {!gerador.fone ? "Não informado" : mascaras.celularMask(gerador.fone)}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Celular: </span> {gerador.celular && gerador.celular.length > 0 ? gerador.celular : "Não informado"}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Categoria: </span> {gerador.categoria}</p>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Característica: </span> {gerador.caracteristica}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Ramo de atividade: </span> {gerador.tbSegmentos_Descricao}</p>
                        </Col>
                        {gerador.dataValidade &&
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Data Validade: </span> {moment(gerador.dataValidade).format("DD/MM/YYYY")}</p>
                            </Col>
                        }
                    </Row>
                </div>
                <div>
                <h5 style={{ color: "#fff" }} className='p-2 rounded-3 bg-gradient bg-primary fw-normal d-flex justify-content-between align-items-center'> <span><FontAwesomeIcon icon={faMapMarkerAlt} className={"me-3"} />Endereços</span>{true && <button onClick={null} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }} color='info'><FontAwesomeIcon icon={faEdit} /></button>} </h5>
                    <TabelaEnderecos
                        enderecos={gerador.localidades}
                        paging={false}
                        integracaoCadastros={true}
                        analiseLocalidade={permissaoEditarGerador?.permissao == "Editar" ? analisarLocalidade : null}
                        visualizarAnaliseLocalidade={visualizarAnaliseLocalidade}
                    />
                </div>
                <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                    <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
                </h5>
                <Row>
                    {gerador?.documentos.map((documento, index) => (
                        <Col lg={3} key={index} className="mb-3">
                            <div className="card shadow h-100">
                                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                    <div className="d-flex flex-column align-items-center">
                                        <label htmlFor={`file-upload-${index}`} className="mb-3">
                                            <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                                        </label>
                                    </div>

                                    <div className="mb-3">
                                        <strong>{documento.identificacao || "Documento"}</strong>
                                    </div>

                                    <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                                        if (documento.arquivo.includes(".pdf"))
                                            window.open(documento.arquivo, "_blank")
                                        else
                                            abrirPDF(documento.arquivo);
                                    }}>
                                        <FontAwesomeIcon icon={faEye} /> Visualizar
                                    </button>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </MainCard>
    );
}